export const NAME_TO_DOMAIN_MAPPINGS_FORM = 'nameToDomain'
